import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export default function PhoneOtp({ phone, verified, onEnabled, onVerified }) {
  const [enabled, setEnabled] = useState(false);
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [wait, setWait] = useState(0);
  useEffect(() => { api.get("/auth/config").then((r) => { setEnabled(r.data.otp_enabled); onEnabled(r.data.otp_enabled); }); }, []); // eslint-disable-line
  useEffect(() => { if (wait > 0) { const t = setTimeout(() => setWait(wait - 1), 1000); return () => clearTimeout(t); } }, [wait]);
  useEffect(() => { setSent(false); setCode(""); }, [phone]);
  if (!enabled) return null;
  if (verified) return <p data-testid="otp-verified" className="text-xs text-emerald-400 mt-1 pl-1 flex items-center gap-1"><CheckCircle2 size={12} />Mobile number verified</p>;

  const send = async () => {
    setBusy(true);
    try { await api.post("/auth/otp/send", { phone }); setSent(true); setWait(30); toast.success("OTP sent by SMS"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const verify = async () => {
    setBusy(true);
    try { const r = await api.post("/auth/otp/verify", { phone, code }); onVerified(r.data.phone_token); toast.success("Mobile verified"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const valid = /^[6-9]\d{9}$/.test(phone);
  return (
    <div className="mt-2 flex gap-2" data-testid="otp-box">
      {sent && <input data-testid="otp-code-input" inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="Enter OTP" className="flex-1 min-w-0 h-10 rounded-xl bg-white/5 border border-white/10 px-3 text-sm font-mono tracking-widest outline-none focus:border-[#ff5500]/60" />}
      {sent && <button type="button" data-testid="otp-verify-button" disabled={code.length < 4 || busy} onClick={verify} className="px-4 rounded-xl bg-emerald-500 text-sm font-semibold disabled:opacity-40">Verify</button>}
      <button type="button" data-testid="otp-send-button" disabled={!valid || busy || wait > 0} onClick={send} className={`${sent ? "" : "flex-1"} px-4 h-10 rounded-xl border border-[#00f0ff]/40 text-[#00f0ff] text-sm font-semibold disabled:opacity-40`}>
        {wait > 0 ? `Resend in ${wait}s` : sent ? "Resend" : "Send OTP"}
      </button>
    </div>
  );
}
